import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-mining-plan',
  templateUrl: './add-mining-plan.component.html',
  styleUrl: './add-mining-plan.component.css'
})
export class AddMiningPlanComponent implements OnInit {
  optionsMap: { [key: string]: any[] } = {
    countries: [{ value: 'India', label: 'India' }],
    states: [],
    districts: [],
    subDistricts: [],
    villages: [],
    delivers: [
        { label: 'by courier', value: 'by courier' },
        { label: 'at supertech', value: 'at supertech' }
    ],
    status: [
        { label: 'Delivered', value: 'Delivered' },
        { label: 'Pending', value: 'Pending' }
      ],
  };
  formFields = [
    { key: 'clientName', label: 'Client Name', type: 'text', value: '', required: true },
    { key: 'COUNTRY', label: 'Country', type: 'select', value: '', optionKey: 'countries', onChange: () => this.onCountryStateChange(), required: true },
    { key: 'state', label: 'State', type: 'select', value: '', optionKey: 'states', onChange: () => this.onStateChange(), required: true },
    { key: 'district', label: 'District', type: 'select', value: '', optionKey: 'districts', onChange: () => this.onStatedistrictsChange(), required: true },
    { key: 'tehsil', label: 'Tehsil', type: 'select', value: '', optionKey: 'subDistricts', onChange: () => this.onStatedistrictssubDistrictsChange(), required: true },
    { key: 'village', label: 'Village', type: 'select', value: '', optionKey: 'villages', required: true },
    { key: 'mineral', label: 'Mineral', type: 'text', value: '' },
    { key: 'area', label: 'Area (in Hectare)', type: 'number', value: '' },
    { key: 'rqp', label: 'RQP', type: 'text', value: '' },
    { key: 'approvalDate', label: 'Date of Approval', type: 'date', value: '' },
    { key: 'hardcopies', label: 'Hardcopies', type: 'number', value: '' },
    {
      key: 'deliver', label: 'Deliver Method', type: 'select',optionKey: 'delivers'
    },
    {
      key: 'status', label: 'Status', type: 'select',optionKey: 'status' 
    },
    { key: 'remark', label: 'Remark', type: 'textarea', value: '' },
    { key: 'preparedBy', label: 'Prepared By', type: 'text', value: '' },
    { key: 'fileNo', label: 'File No.', type: 'text', value: '' }
  ];
  miningForm: FormGroup;
  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }
  ngOnInit(): void {
    this.miningForm = this.fb.group({});
    this.formFields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      this.miningForm.addControl(field.key, this.fb.control(field.value || '', validators));
    });
  }

  onCountryStateChange() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.optionsMap['states'] = (res as any[]).map(state => ({
          value: state,
          label: state
        }));
        this.miningForm.get('state')?.setValue('');
        this.optionsMap['districts'] = [];
      },
      error: (err) => this.toastrMsgService.error(err.error.errorMessage)
    });
  }

  onStateChange() {
    const selectedState = this.miningForm.get('state')?.value;
    console.log(selectedState)
    if (selectedState) {
      this.apiService.getdistricts(selectedState).subscribe({
        next: (res) => {
          this.optionsMap['districts'] = (res as any[]).map(city => ({
            value: city,
            label: city
          }));
          this.miningForm.get('district')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }
  }
  onStatedistrictsChange() {
    const state = this.miningForm.value.state;
    const district = this.miningForm.value.district;
    if (district) {
      this.apiService.getSubdistricts(state, district).subscribe({
        next: (res) => {
          this.optionsMap['subDistricts'] = (res as any[]).map(subDis => ({
            value: subDis,
            label: subDis
          }));
          this.miningForm.get('tehsil')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }
  onStatedistrictssubDistrictsChange() {
    const state = this.miningForm.value.state;
    const district = this.miningForm.value.district;
    const subdistrict = this.miningForm.value.tehsil;
    if (subdistrict) {
      this.apiService.getvillages(state, district, subdistrict).subscribe({
        next: (res) => {
          this.optionsMap['villages'] = (res as any[]).map(vill => ({
            value: vill,
            label: vill
          }));
          this.miningForm.get('village')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }
    onSubmit(): void {
    if (this.miningForm.valid) {
      console.log('Form Submitted:', this.miningForm.value);
    }
  }

  onReset(): void {
    this.miningForm.reset();
  }
}
